module.exports = __webpack_public_path__ + "img/link-icon.a7afd43e.svg";